import { SPECIALIST_DETAILS } from 'constants/ActionTypes'
import { validSteps } from '../Linkgua/components/SpecialistDetails'

const initialSystemState = {
  specialistDetails: {
    step: validSteps.personal
  }
}

const Components = (state = initialSystemState, action) => {
  switch (action.type) {
    case SPECIALIST_DETAILS:
      return {
        ...state,
        specialistDetails: {
          step: action.step
        }
      }

    default:
      return state
  }
}

export default Components



// WEBPACK FOOTER //
// ./reducers/Components.js